import React from 'react';
import { AlertError, FormDashboardInput, FormDashboardLabel as Label, FormDashboardTextarea, FormRow, ImagePickerSidebar, Button } from '../../../../../components';

const TestimonialFormDumb = ({
  form,
  handleInput,
  handleImage,
  errorMessage,
  setErrorMessage,
  handleSave,
  requesting,
  withImage
}) => {
  return <>
    <FormRow>
      <Label>Name</Label>
      <FormDashboardInput
        className="w-full"
        placeholder="Name"
        name="name"
        defaultValue={form.name}
        onChange={e => {e.persist(); handleInput(e)}}
      />
    </FormRow>

    <FormRow>
      <Label>Description</Label>
      <FormDashboardTextarea
        className="w-full"
        name="description"
        defaultValue={form.text}
        onChange={e => {e.persist(); handleInput(e)}}
      />
    </FormRow>

    {
      withImage &&
      <FormRow>
        <Label>Photo Profile</Label>
        <ImagePickerSidebar
          height="100px"
          onChange={handleImage}
          defaultValue={form.image}
        />
      </FormRow>
    }

    {
      errorMessage !== null &&
      <div className="mb-8">
        <AlertError message={errorMessage} onClose={() => setErrorMessage(null)}/>
      </div>
    }

    <Button
      className="inline-block w-full lg:w-auto"
      style={{ minWidth: "197px" }}
      onClick={handleSave}
      disabled={requesting}
      isLoading={requesting}
    >
      Save
    </Button>
  </>
}

export default TestimonialFormDumb
